import { FC } from 'react';
import Page404 from '../../404/404';
import UserDetails, { OrderDetails } from '../OrderDetails';
import { useSelector } from 'react-redux';

const ErrorMiddlewareUserDetails: FC<{ token: any; location?: any }> = (props: any) => {
  const orderDetailsIsError = useSelector((state: any) => state.rootReducer.userDetails?.isError);
  const orderDetails = useSelector((state: any) => state.rootReducer.userDetails?.oneOrderData);

  if (orderDetailsIsError) {
    return <Page404 />;
  } else {
    return <OrderDetails {...props} state={orderDetails} />;
  }
};

export default ErrorMiddlewareUserDetails;
